<mat-tab-group>
    <mat-tab label="General data">
        <mat-card style="margin: 10px;">
            <mat-card-header>
                <mat-card-title>Event information</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="info-row">
                    <span class="label">Name</span>
                    <span class="value">{{ event.name }}</span>
                </div>

                <div class="info-row">
                    <span class="label">Shortname</span>
                    <span class="value">{{ event.shortName }}</span>
                </div>

                <div class="info-row">
                    <span class="label">Start date</span>
                    <span class="value">{{ event.date | date:'dd/MM/yyyy' }}</span>
                </div>

                @if (event.endDate) {
                <div class="info-row">
                    <span class="label">End date</span>
                    <span class="value">{{ event.endDate | date:'dd/MM/yyyy' }}</span>
                </div>
                }

                <div class="info-row url-row">
                    <span class="label">Event URL</span>
                    <span class="value ellipsis">{{ event.url ?? 'N/A' }}</span>

                    @if (event.url) {
                    <button mat-icon-button (click)="copy(event.url)" matTooltip="Copy URL to clipboard"
                        aria-label="Copy URL">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                    }
                </div>

                <div class="info-row">
                    <span class="label">Free event</span>
                    <span class="value">{{ event.freeEvent ? 'yes' : 'no' }}</span>
                </div>

                <div class="info-row">
                    <span class="label">Location</span>
                    <span class="value">{{ event.location ?? '...' }}</span>
                </div>

                <div class="info-row">
                    <span class="label">Registration open from</span>
                    <span class="value">
                        {{ event.registrationOpenDate ? (event.registrationOpenDate | date:'dd/MM/yyyy') : '...' }}
                        to
                        {{ event.registrationCloseDate ? (event.registrationCloseDate | date:'dd/MM/yyyy') : '...' }}
                    </span>
                </div>

                <div class="info-row url-row">
                    <span class="label">Hotel booking URL</span>
                    <span class="value ellipsis">{{ event.hotelBookingUrl ?? 'N/A' }}</span>

                    @if (event.hotelBookingUrl) {
                    <button mat-icon-button (click)="copy(event.hotelBookingUrl)" matTooltip="Copy URL to clipboard"
                        aria-label="Copy URL">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                    }
                </div>

                <div class="info-row">
                    <span class="label">Allow multiple registrations</span>
                    <span class="value">{{ event.allowMultipleRegistrations ? 'yes' : 'no' }}

                    </span>
                </div>

                @if (!event.freeEvent) {

                <div class="info-row">
                    <span class="label">Early bird deadline</span>
                    <span class="value">
                        {{ event.earlyBirdDeadline ? (event.earlyBirdDeadline | date:'dd/MM/yyyy') : 'N/A' }}
                    </span>
                </div>

                <div class="info-row">
                    <span class="label">Uses promocodes</span>
                    <span class="value">{{ event.usesPromoCodes ? 'yes' : 'no' }}</span>
                </div>

                <div class="info-row">
                    <span class="label">Free tickets</span>
                    <span class="value">
                        {{ event.oneFreeFor == 0 ? 'no' : '1 free ticket for ' + event.oneFreeFor + ' paid tickets' }}
                    </span>
                </div>

                <div class="info-row">
                    <span class="label">Fees</span>
                    <div class="value fee-list">
                        @for (fee of event.fees; track fee.id) {
                        <div class="fee-line">
                            <span class="fee-name">{{ fee.name }}</span>
                            <span class="fee-audience">{{ fee.target }}</span>
                            <span class="fee-price">{{ fee.earlyBirdPrice != null ? (fee.earlyBirdPrice |
                                currency:'EUR':'symbol':undefined:'fr-BE') : 'N/A' }}</span>
                            <span class="fee-price">{{ fee.generalPrice | currency:'EUR':'symbol':undefined:'fr-BE'
                                }}</span>
                        </div>
                        }
                        @if (!event.fees || event.fees.length === 0) {
                        <span>No fee defined</span>
                        }
                    </div>
                </div>
                }
            </mat-card-content>
            <mat-card-actions class="edit-actions">
                <button mat-raised-button color="primary" (click)="editEvent()">
                    <mat-icon>edit</mat-icon>
                    Edit event
                </button>
                <button mat-raised-button color="primary" (click)="generateParticipantsList()">
                    <mat-icon>download</mat-icon>
                    Generate the participants list
                </button>
            </mat-card-actions>
        </mat-card>
    </mat-tab>

    @if (event?.freeEvent) {
    <mat-tab label="List of registrations">
        <div style="margin:10px">
            <app-event-free-registrations></app-event-free-registrations>
        </div>
    </mat-tab>
    } @else {
    @if (event?.usesPromoCodes) {
    <mat-tab label="Promocodes">
        <div style="margin:10px">
            <app-event-promocodes></app-event-promocodes>
        </div>
    </mat-tab>
    }
    <mat-tab label="List of registrations">
        <div style="margin:10px">
            <app-event-registrations></app-event-registrations>
        </div>
    </mat-tab>
    }
    <mat-tab label="Preference summary">
        <div style="margin:10px">
            <app-event-preferences></app-event-preferences>
        </div>
    </mat-tab>
</mat-tab-group>